import { FormEvent } from "react";
import { DropdownV2, FormCardV2, FormGridV2, InputV2 } from "../FormControlsV2";
import { FormActions } from "./FormActions";
import { MicroAreaFormProps, MicroAreaFormValueV2 } from "./types";
import { isDisabled, parseCoords, stringifyCoords } from "./utils";

export function MicroAreaFormV2({
  value,
  mode = "create",
  errors = {},
  disabledFields = [],
  cardTitle,
  cardDescription,
  showCardHeader = true,
  farms,
  areas,
  reasons = [],
  initialsPrefix,
  availableArea,
  mapSlot,
  headerActions,
  showActions = true,
  onChange,
  onBlur,
  onSubmit,
  onCancel,
  onFarmChange,
  onAreaChange,
}: MicroAreaFormProps) {
  function update(partial: Partial<MicroAreaFormValueV2>) {
    onChange({ ...value, ...partial });
  }

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    onSubmit && onSubmit(value);
  }

  return (
    <form className="ov2-property-form" onBlur={onBlur} onSubmit={handleSubmit}>
      <FormCardV2
        title={showCardHeader ? cardTitle || "Pasto" : undefined}
        description={showCardHeader ? cardDescription : undefined}
        actions={headerActions}
      >
        <div className="ov2-property-form__layout">
          <FormGridV2>
            <DropdownV2
              name="farm"
              label="Fazenda"
              value={value.farm}
              options={farms}
              searchable
              disabled={isDisabled("farm", mode, disabledFields)}
              error={errors.farm}
              onChange={(farm) => {
                onFarmChange && onFarmChange(farm);
                update({ farm, area: null });
              }}
            />
            <DropdownV2
              name="area"
              label="Retiro"
              value={value.area}
              options={areas}
              searchable
              disabled={isDisabled("area", mode, disabledFields) || !value.farm}
              error={errors.area}
              onChange={(area) => {
                onAreaChange && onAreaChange(area);
                update({ area });
              }}
            />
            <InputV2
              name="initials"
              label="Sigla"
              prefix={initialsPrefix}
              value={value.initials}
              maxLength={4}
              disabled={isDisabled("initials", mode, disabledFields)}
              error={errors.initials}
              onChange={(initials) => update({ initials: initials.toUpperCase() })}
            />
            {reasons.length > 0 && (
              <DropdownV2
                name="reason"
                label="Motivo para não utilizar o pasto"
                value={value.reason || null}
                options={reasons}
                searchable
                disabled={isDisabled("reason", mode, disabledFields)}
                error={errors.reason}
                onChange={(reason) => update({ reason })}
              />
            )}
          </FormGridV2>

          <div className="ov2-property-form__map">
            {mapSlot || (
              <InputV2
                name="map_coords"
                label="Coordenadas do mapa"
                type="textarea"
                value={stringifyCoords(value.map_coords)}
                disabled={isDisabled("map_coords", mode, disabledFields)}
                error={errors.map_coords}
                onChange={(coords) => update({ map_coords: parseCoords(coords) })}
              />
            )}
            <div className="ov2-property-acreage-tag">
              <span>Área útil</span>
              <strong>{value.acreage || "0"} ha</strong>
            </div>
            {errors.acreage && (
              <small className="ov2-field__error animation__fadeIn">{errors.acreage}</small>
            )}
          </div>
        </div>
      </FormCardV2>

      {showActions && <FormActions mode={mode} onCancel={onCancel} />}
    </form>
  );
}
